import { useEffect, useState } from "react";
import api, { API } from "../lib/api";
import ThemeHtmlRenderer from "./ThemeHtmlRenderer";

/* Storefront delivery for imported themes — native render (no iframe).
   The served page is the CONVERTED theme: original design preserved, business
   fields injected server-side, products/categories and all commerce CTAs wired
   to MILTROO's native e-commerce routes by the mz-runtime (real navigation). */
export default function ImportedTheme({ slug, engine = "static" }) {
  const [html, setHtml] = useState("");
  const [err, setErr] = useState("");

  // SPA/framework themes hydrate the whole document — serve the converted page AS
  // the document (top-level redirect to the backend-rendered page, no iframe).
  useEffect(() => {
    if (engine === "spa") window.location.replace(`${API}/public/store/${slug}/page`);
  }, [slug, engine]);

  useEffect(() => {
    if (engine === "spa") return;
    api.get(`/public/store/${slug}/page`, { responseType: "text" })
      .then((r) => setHtml(r.data))
      .catch(() => setErr("This store page could not be loaded."));
  }, [slug, engine]);

  if (err) return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <p data-testid="imported-theme-error" className="text-muted-foreground">{err}</p>
    </div>
  );
  if (!html) return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="h-10 w-10 rounded-full border-2 border-border border-t-foreground animate-spin" />
    </div>
  );
  return <ThemeHtmlRenderer html={html} mode="live" testid="imported-theme-root" />;
}
